export const articleTypeBindings = {
  'listing-article': 'Listing Article',
  'educational-article': 'Educational Article',
  'presell-article': 'Presell Article',
};
